import { fetchTopSellingCourses } from '../../api/topSellingApi'
import { ourCoursesActions } from './ourCoursesSlice'

export const getOurCourses = () => async dispatch => {
    dispatch(ourCoursesActions.getOurCourses())
    try {
        const courses = await fetchTopSellingCourses()
        dispatch(ourCoursesActions.getOurCoursesSuccess(courses))
    } catch (e) {
        dispatch(ourCoursesActions.getOurCoursesError(e.message))
    }
}
